import React from 'react';

import { IconStyled } from './Icon.styled';

export const Icon = ({ src, alt }: any) => {
  return <IconStyled src={src} alt={alt} />;
};
